import { useMemo } from 'react'
import { includes } from 'lodash'

import { areSameValue } from '../../core/utils'

import { ROLES } from '../../common/constants'

import { useLoggedInUser, useUserHasRoles } from '../../account/hooks'
import { MENU_CURATION_TASK_STATUS } from '../constants'

const useUserHasMenuCurationTaskChangePermission = menuCurationTask => {
  const { id: currentUserId } = useLoggedInUser()

  const userCanEditAnyTask = useUserHasRoles([
    ROLES.ADMIN.value,
    ROLES.GUILD_LEAD.value,
  ])

  const userCanEditResolvedTasks = useUserHasRoles([
    ROLES.ADMIN.value,
    ROLES.QC.value,
  ])

  const {
    assignedCurator,
    assignedQa,
    assignedQc,
    assignedTierOneCurator,
    assignedUnknownWordsCurator,
    assignedUnknownWordsQa,
    taskStatus,
  } = menuCurationTask || {}

  const isUserTierOneCurator = useMemo(
    () => areSameValue(assignedTierOneCurator?.id, currentUserId),
    [assignedTierOneCurator?.id, currentUserId],
  )

  const isUserCurator = useMemo(
    () => areSameValue(assignedCurator?.id, currentUserId),
    [assignedCurator?.id, currentUserId],
  )

  const isUserQa = useMemo(
    () => areSameValue(assignedQa?.id, currentUserId),
    [assignedQa?.id, currentUserId],
  )

  const isUserUwCurator = useMemo(
    () => areSameValue(assignedUnknownWordsCurator?.id, currentUserId),
    [assignedUnknownWordsCurator?.id, currentUserId],
  )

  const isUserUwQa = useMemo(
    () => areSameValue(assignedUnknownWordsQa?.id, currentUserId),
    [assignedUnknownWordsQa?.id, currentUserId],
  )

  const isUserQc = useMemo(
    () => areSameValue(assignedQc?.id, currentUserId),
    [assignedQc?.id, currentUserId],
  )

  if (
    userCanEditAnyTask &&
    includes(
      [
        MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_CURATION_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_QA_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value,
        MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value,
      ],
      taskStatus,
    )
  ) {
    return {
      userHasMenuChangePermission: true,
      isUserTierOneCurator: true,
      isUserUwCurator: true,
      isUserUwQa: true,
      isUserCurator: true,
      isUserQa: true,
      isUserQc: true,
    }
  }

  if (
    userCanEditResolvedTasks &&
    includes(
      [
        MENU_CURATION_TASK_STATUS.RESOLVED.value,
        MENU_CURATION_TASK_STATUS.AUTOMATICALLY_RESOLVED.value,
      ],
      taskStatus,
    )
  ) {
    return {
      userHasMenuChangePermission: true,
      isUserTierOneCurator: true,
      isUserUwCurator: true,
      isUserUwQa: true,
      isUserCurator: true,
      isUserQa: true,
      isUserQc: true,
    }
  }

  let options = {
    isUserTierOneCurator,
    isUserUwCurator,
    isUserUwQa,
    isUserCurator,
    isUserQa,
    isUserQc,
  }
  if (
    isUserTierOneCurator &&
    taskStatus === MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value
  ) {
    options = {
      ...options,
      userHasMenuChangePermission: true,
    }
  }

  if (
    isUserCurator &&
    taskStatus === MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value
  ) {
    options = {
      ...options,
      userHasMenuChangePermission: true,
    }
  }

  if (
    isUserUwCurator &&
    taskStatus ===
      MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_CURATION_IN_PROGRESS.value
  ) {
    options = {
      ...options,
      userHasMenuChangePermission: true,
    }
  }

  if (
    isUserUwQa &&
    taskStatus === MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_QA_IN_PROGRESS.value
  ) {
    options = {
      ...options,
      userHasMenuChangePermission: true,
    }
  }

  if (
    isUserQa &&
    taskStatus === MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value
  ) {
    options = {
      ...options,
      userHasMenuChangePermission: true,
    }
  }

  if (
    isUserQc &&
    taskStatus === MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value
  ) {
    options = {
      ...options,
      userHasMenuChangePermission: true,
    }
  }

  return options
}

export default useUserHasMenuCurationTaskChangePermission
